import axios from "axios";
import qs from "qs";
import { v4 as uuidv4 } from "uuid";
import md5 from "md5";
import * as config from "./config";
import Helper from "./../extra/helper";

const getToken = () => {
  let token = Helper.getParamUrl();
  if (!token) {
    const tokenPath = window.location.pathname
      .split("/")
      .filter(Boolean)
      ?.pop()
      ?.split(".")
      ?.filter(Boolean)
      ?.pop();

    token = tokenPath;
  }
  return token;
};  

async function getStime(method, url, data) {
  let token = getToken();
  const res = await axios({
    method: 'GET',
    url: `${config.open_api}/v1/products/stime`,
    data: data,
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${token}`,
    },
  });
  return res;
}

const sortObjectByKey = (obj) => {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObject = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });
  return sortedObject;
};

async function apicall(method, url, dataForm) {
  const token = getToken();
  const queryParams = Object.entries(dataForm)
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  // api lấy time
  const dataStime = await getStime();
  if (dataStime.data.success) {
    const env = config.node_env;
    const data = qs.stringify(sortObjectByKey(dataForm));
    const uuid = uuidv4();
    const client = md5(env + "-" + data + dataStime.data.data.stime + uuid);
    const header = {
      "x-api-stime": dataStime.data.data.stime,
      "x-api-nonce": uuid,
      "x-api-client": client,
    }
    const res = await axios({
      method: method,
      url: `${config.open_api}${url}${(queryParams && method === 'GET') ? `?${queryParams}` : ""}`,
      data: dataForm,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${token}`,
        ...header
      },
    });
    return res;
  }
}

export default {
  apicall
};
